import axios from "axios";
const Url = process.env.REACT_APP_URl;
const UrlDev = process.env.REACT_APP_URl;

export const ProcessImageServ = async (obj: any) => {
    const response = await axios.post(UrlDev + "/Processimage", obj, {
        headers: {
            
            "Authorization": "Bearer " + localStorage.getItem("usertoken")
        }
    })
    return response.data;
}


export const ImageTaggerService = async (obj: any) => {
    const apiUrl = Url + "/image_tagger";
    const response = await axios.post(apiUrl, obj, {
        headers: {
            
            "Authorization": "Bearer " + localStorage.getItem("usertoken")
        }
    })
    return response.data;
}

export const ProcessMultiImageServ = async (obj: any) => {
    const response = await axios.post(UrlDev + "/EnhanceGenerateimages", obj, {
        headers: {
            
            "Authorization": "Bearer " + localStorage.getItem("usertoken")
        },
    })
    return response.data;
}

export const UploadImagesGenerate = async (obj: any) => {
    const response = await axios.post(UrlDev + "/GenerateEnhanceCreation", obj, {
        headers: {
            
            "Authorization": "Bearer " + localStorage.getItem("usertoken")
        }
    })
    return response.data;
}

export const CleeanImages = async (proccessId: any) => {
    const response = await axios.get(UrlDev + "/cleeanup/" + proccessId, {
        headers: {
            
            "Authorization": "Bearer " + localStorage.getItem("usertoken")
        }
    })
    return response.data;
}

export const RemoveFurniture = async (img: string) => {
    const response = await axios.post(UrlDev + "/removefurniture", { "image": img }, {
        headers: {
            
            "Authorization": "Bearer " + localStorage.getItem("usertoken")
        }
    })
    return response.data;
}


export const DetectFurnitureMasks = async (data: any) => {
    const response = await axios.post(UrlDev + "/detect_furniture_masks", data, {
        headers: {
            "Authorization": "Bearer " + localStorage.getItem("usertoken")
        }
    })
    return response.data;
}


export const RemoveObject = async (data: any) => {
    const response = await axios.post(UrlDev + "/remove_object_manual_single", data, {
        headers: {
            "Authorization": "Bearer " + localStorage.getItem("usertoken")
        }
    })
    return response.data;
}


export const SaveEnhancedImage = async (data: any) => {
    const response = await axios.post(UrlDev + "/update_process_image", data, {
        headers: {
            "Authorization": "Bearer " + localStorage.getItem("usertoken")
        }
    })
    return response.data;
}

export const SaveImageAfterEdit = async (proccessId: any, imageid: string | number, new_image: string) => {
    const response = await axios.post(UrlDev + "/saveimage_afteredit", { processid: proccessId, imageid: imageid, new_image: new_image }, {
        headers: {
            
            "Authorization": "Bearer " + localStorage.getItem("usertoken")
        }
    })
    return response.data;
}